import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PdfTemplateService {

  generatePatientFormHTML(caseData: any, pdfHelper: any): string {
    const formData = this.prepareFormData(caseData, pdfHelper);

    return `
<!DOCTYPE html>
<html lang="tr">
<head>
  <meta charset="UTF-8">
  <title>T.C. SAĞLIK BAKANLIĞI - HASTA MUAYENE/GÖZLEM FORMU</title>
  <style>
    ${this.getFormStyles()}
  </style>
</head>
<body>
<div class="form-container">
  ${this.renderHeader()}
  ${this.renderSerialNumber()}
  ${this.renderMainInfoTable(formData)}
  ${this.renderSGKTable()}
  ${this.renderCallTypeTable(formData)}
  ${this.renderExaminationTable(formData)}
  ${this.renderDiagnosisTable(formData)}
  ${this.renderResultTable()}
  ${this.renderProcedureTable(formData)}
  ${this.renderConsentSection(formData)}
  ${this.renderSignatureTable(formData)}
  ${this.renderFooter()}
</div>

<script>
  window.onload = function() {
    setTimeout(()=>window.print(), 500);
  };
</script>
</body>
</html>`;
  }

  private prepareFormData(caseData: any, pdfHelper: any) {
    const motor = pdfHelper.createCheckboxListLabel(caseData, 'Glasgow Koma Skalası - Motor', caseData?.options?.glasgowMotorOptions);
    const verbal = pdfHelper.createCheckboxListLabel(caseData, 'Glasgow Koma Skalası - Verbal', caseData?.options?.glasgowVerbalOptions);
    const goz = pdfHelper.createCheckboxListLabel(caseData, 'Glasgow Koma Skalası - Göz Açma', caseData?.options?.glasgowGozOptions);
    const glasgowTotal = motor.totalScore + verbal.totalScore + goz.totalScore;

    const pupiller = pdfHelper.createCheckboxListLabel(caseData, 'Pupiller', caseData?.options?.pupillerOptions);
    const deri = pdfHelper.createCheckboxListLabel(caseData, 'Deri', caseData?.options?.deriOptions);
    const solunum = pdfHelper.createCheckboxListLabel(caseData, 'Solunum', caseData?.options?.solunumOptions);
    const bloodPress = pdfHelper.createCheckboxListLabel(caseData, 'blood-press', caseData?.options?.bloodPressOptions);
    const pulse = pdfHelper.createCheckboxListLabel(caseData, 'pulse', caseData?.options?.pulseOptions);
    const kurtarma = pdfHelper.createCheckboxListLabel(caseData, 'Kurtarma Yapıldı Mı?');

    // Personel bilgilerini ayır
    const watchArray = caseData?.data?.watchArray ?? [];
    const doctor = watchArray.find((staff: any) =>
      staff.watchRoleName?.toLowerCase()?.includes('doktor') ??
      staff.watchRoleName?.toLowerCase()?.includes('hekim')
    );
    const driver = watchArray.find((staff: any) =>
      staff.watchRoleName?.toLowerCase()?.includes('sürücü')
    );
    const healthPersonnel = watchArray.filter((staff: any) =>
      !staff.watchRoleName?.toLowerCase()?.includes('doktor') &&
      !staff.watchRoleName?.toLowerCase()?.includes('hekim') &&
      !staff.watchRoleName?.toLowerCase()?.includes('sürücü')
    );

    return {
      motor,
      verbal,
      goz,
      glasgowTotal,
      pupiller,
      deri,
      solunum,
      kurtarma,
      bloodPress,
      pulse,
      pdfHelper,
      caseData,
      doctor,
      driver,
      healthPersonnel
    };
  }

  private getFormStyles(): string {
    return `
      * { margin:0; padding:0; box-sizing:border-box; }
      body { font-family: Arial, sans-serif; font-size: 10px; color:#000; }
      .form-container { width:210mm; min-height:297mm; margin:0 auto; padding:10mm; }
      .header { text-align:center; font-weight:bold; margin-bottom:10px; }
      .header h1 { font-size:14px; }
      .header h2 { font-size:12px; }
      .header h3 { font-size:11px; }
      .serial { text-align:right; font-size:9px; margin-bottom:5px; }
      table { width:100%; border-collapse:collapse; margin-bottom:6px; }
      th, td { border:1px solid #000; padding:2px; vertical-align:top; font-size:8px; }
      .section-header { background:#f0f0f0; font-weight:bold; text-align:center; }
      .checkbox-item { display:flex; align-items:center; gap:3px; font-size:8px; }
      .checkbox-item-2 { display: inline-block; margin-right: 12px; margin-bottom: 6px; white-space: nowrap; font-size:8px; }
      input[type=checkbox] { width:10px; height:10px; }
      .footer { font-size:7px; margin-top:8px; line-height:1.3; }
      .vital-signs-row { font-size:7px; }
      .vital-input { width: 40px; border: none; border-bottom: 1px solid #000; background: transparent; text-align: center; }
    `;
  }

  private renderHeader(): string {
    return `
      <div class="header">
        <h1>T.C. SAĞLIK BAKANLIĞI</h1>
        <h2>ÖZEL ACIBADEM MOBİL SAĞLIK AMBULANS SERVİSİ</h2>
        <h3>HASTA MUAYENE/GÖZLEM FORMU</h3>
      </div>
    `;
  }

  private renderSerialNumber(): string {
    return `
      <div class="serial">
        Seri No: 34Ö-061-0000001<br>
        (Takip eden numaralar olacak, fatura gibi)
      </div>
    `;
  }

  private renderMainInfoTable(formData: any): string {
    const { caseData, pdfHelper } = formData;
    return `
      <table>
        <tr class="section-header">
          <td colspan="3">İSTASYON</td>
          <td colspan="3">SAATLER</td>
          <td colspan="4">HASTA BİLGİLERİ</td>
        </tr>
        <tr>
          <td>Adı :</td>
          <td colspan="2">${caseData?.data?.dot?.dotName ?? ''}</td>
          <td>Çağrı Saati :</td>
          <td colspan="2">${pdfHelper.formatDate(caseData?.data?.callDate)}</td>
          <td>Adı :</td>
          <td colspan="3">${caseData?.data?.cases?.patientInformations?.firstName ?? ''}</td>
        </tr>
        <tr>
          <td>Prot. No :</td>
          <td colspan="2">${caseData?.data?.cases?.caseNo ?? ''}</td>
          <td>Vakaya Çıkış :</td>
          <td colspan="2">${pdfHelper.formatDate(caseData?.data?.ongoingDate)}</td>
          <td>Soyadı :</td>
          <td colspan="3">${caseData?.data?.cases?.patientInformations?.lastName ?? ''}</td>
        </tr>
        <tr>
          <td>Tarih :</td>
          <td colspan="2">${pdfHelper.formatDateOnly(caseData?.data?.cases?.caseDate)}</td>
          <td>Olay Yerine Varış :</td>
          <td colspan="2">${pdfHelper.formatDate(caseData?.data?.arriveDate)}</td>
          <td>T.C. :</td>
          <td colspan="3">${caseData?.data?.cases?.patientInformations?.idNumber ?? ''}</td>
        </tr>
        <tr>
          <td>Plaka :</td>
          <td colspan="2">${caseData?.data?.vehicle?.licensePlate ?? ''}</td>
          <td>Olay Yerinden Ayrılış :</td>
          <td colspan="2">${pdfHelper.formatDate(caseData?.data?.caseEndDate)}</td>
          <td>Baba Adı :</td>
          <td colspan="3">${caseData?.data?.cases?.patientInformations?.patient?.fathersName ?? ''}</td>
        </tr>
        <tr>
          <td>Kodu :</td>
          <td colspan="2">${caseData?.data?.vehicle?.vehicleNo ?? ''}</td>
          <td>Hastaneye Varış :</td>
          <td colspan="2"></td>
          <td>Doğum Tarihi :</td>
          <td colspan="3">${pdfHelper.formatDateOnly(caseData?.data?.cases?.patientInformations?.patient?.birthDate) ?? ''}</td>
        </tr>
        <tr>
          <td></td><td colspan="2"></td>
          <td>Hastaneden Ayrılış :</td>
          <td colspan="2"></td>
          <td>Cinsiyet :</td>
          <td> E
              <input type="checkbox" style="transform:scale(1.2);" 
                ${caseData?.data?.cases?.patientInformations?.gender?.toLowerCase() === 'male' ? 'checked' : ''} onclick="return false;"/>
            </td>
            <td colspan="2"> K
              <input type="checkbox" style="transform:scale(1.2);" 
                ${caseData?.data?.cases?.patientInformations?.gender?.toLowerCase() === 'female' ? 'checked' : ''} onclick="return false;"/>
            </td>
        </tr>
        <tr>
          <td></td><td colspan="2"></td>
          <td>İstasyona Dönüş :</td>
          <td colspan="2"></td>
          <td>Telefonu :</td>
          <td colspan="3">
            ${(caseData?.data?.cases?.patientInformations?.contacts ?? [])
        .find((c: any) => c.priority === true && c.phone) // priority true ve phone dolu
        ?.phone ?? ''
      }
          </td>
        </tr>
        <tr>
          <td colspan="3"></td>
          <td colspan="3"></td>
          <td>Olay Yeri Adresi :</td>
          <td colspan="3">${caseData?.data?.cases?.addressInformations?.pickupAddress?.formattedAddress ?? ''}</td>
        </tr>
      </table>
    `;
  }

  private renderSGKTable(): string {
    return `
    <table style="width:100%; border-collapse:collapse; table-layout:fixed; text-align:center; font-size:9px;">
      <tr class="section-header">
        <td colspan="3" style="font-weight:bold; text-align:center; padding:6px;">
          HASTANIN SOSYAL GÜVENLİK BİLGİLERİ
        </td>
      </tr>
      <tr>
        <td style="border:1px solid #000; padding:6px; vertical-align:middle;">SGK</td>
        <td style="border:1px solid #000; padding:6px; vertical-align:middle;">SAĞLIK TURİZMİ</td>
        <td style="border:1px solid #000; padding:6px; vertical-align:middle;">GÜVENCESİZ (18–65 YAŞ ARASI)</td>
      </tr>
      <tr>
        <td style="border:1px solid #000; padding:6px; vertical-align:middle;">
          <input type="checkbox" style="transform:scale(1.2);" onclick="return false;"/>
        </td>
        <td style="border:1px solid #000; padding:6px; vertical-align:middle;">
          <input type="checkbox" style="transform:scale(1.2);" onclick="return false;"/>
        </td>
        <td style="border:1px solid #000; padding:6px; vertical-align:middle;">
          <input type="checkbox" style="transform:scale(1.2);" onclick="return false;"/>
        </td>
      </tr>
    </table>
  `;
  }


  private renderCallTypeTable(formData: any): string {
    const { caseData, pdfHelper } = formData;

    return `
      <table>
        <tr class="section-header">
          <td>ÇAĞRI TİPİ</td>
          <td>OLAY YERİ</td>
          <td colspan="3">ÇAĞRI NEDENİ</td>
        </tr>
        <tr>
          <td>
            <label class="checkbox-item"><input type="checkbox"> Telsiz</label>
            <label class="checkbox-item"><input type="checkbox"> Telefon</label>
            <label class="checkbox-item"><input type="checkbox"> Online</label>
            <label class="checkbox-item"><input type="checkbox"> Diğer</label>
          </td>
          <td>
            ${this.renderEventLocationCheckboxes()}
          </td>
          <td>
            ${pdfHelper.createCheckboxList(caseData?.options?.causeReasonOptions, caseData?.data?.cases?.caseInformations?.causeReason?.id)}
          </td>
        </tr>
      </table>
    `;
  }

  private renderEventLocationCheckboxes(): string {
    const locations = ['Ev', 'Yaya', 'Büro', 'Suda', 'Arazi', 'Sokak', 'Araçta', 'Otel',
      'Sağlık Kurumu', 'Cami vb.', 'Lokanta', 'Resmi Daire', 'Spor Salonu',
      'Fabrika', 'Banka', 'Eğitim Kurumu', 'Stadyum', 'Yurt', 'Huzurevi', 'Diğer'];

    return locations.map(location =>
      `<label class="checkbox-item-2"><input type="checkbox"> ${location}</label>`
    ).join(' ');
  }

  private renderExaminationTable(formData: any): string {
    const { motor, verbal, goz, glasgowTotal, pupiller, deri, solunum, bloodPress, pulse, caseData, pdfHelper, kurtarma } = formData;

    // Kurtarma checkbox'larını ayır
    const isKurtarmaEvet = kurtarma.html.includes('Evet');

    return `
    <table>
      <tr class="section-header">
        <td colspan="6">İLK MUAYENE BULGULARI</td>
        <td colspan="3">GLASGOW KOMA SKALASI</td>
        <td>DURUMU</td>
      </tr>
      <tr>
        <td>Pupiller</td>
        <td>Deri</td>
        <td>Saat</td>
        <td>Kan Basıncı</td>
        <td>Nabız</td>
        <td>Solunum</td>
        <td>Motor</td>
        <td>Verbal</td>
        <td>Göz Açma</td>
        <td rowspan="5">
          ${pdfHelper.createCheckboxList(
      caseData?.options?.triageOptions,
      caseData?.data?.cases?.caseInformations?.triage?.id
    )}
        </td>
      </tr>
      <tr>
        <td rowspan="4" style="vertical-align:top;">${pupiller.html}</td>
        <td rowspan="4" style="vertical-align:top;">${deri.html}</td>
        <td rowspan="4" style="vertical-align:top; font-size:7px;">
          1 &nbsp;&nbsp;&nbsp;<br>
          2 &nbsp;&nbsp;&nbsp;<br>
          3 &nbsp;&nbsp;&nbsp;<br>
        </td>
        <td rowspan="4" style="vertical-align:top;">${bloodPress.html}</td>
        <td rowspan="4" style="vertical-align:top;">${pulse.html}</td>
        <td rowspan="4" style="vertical-align:top;">${solunum.html}</td>
        <td rowspan="4" style="vertical-align:top;">${motor.html}</td>
        <td rowspan="4" style="vertical-align:top;">${verbal.html}</td>
        <td rowspan="4" style="vertical-align:top;">${goz.html}</td>
      </tr>
      <tr></tr>
      <tr></tr>
      <tr></tr>
      <tr>
       <td colspan="6" style="text-align:right; font-size:8px; padding:5px;">
        </td>
        <td colspan="3" style="text-align:right; font-size:8px; padding:5px;">
          <strong>G.K.S. Puanı: ${glasgowTotal}</strong>
        </td>
        <td colspan="1" style="text-align:left; font-size:8px; padding:5px;">
          <div style="display:inline-block; margin-right:20px;">
            Kurtarma Yapıldı mı?<br>
            <label class="checkbox-item" style="display:inline; margin:0 5px;">
              <input type="checkbox" ${isKurtarmaEvet ? 'checked' : ''} onclick="return false;"> E
            </label>
            <label class="checkbox-item" style="display:inline; margin:0 5px;">
              <input type="checkbox" ${isKurtarmaEvet === false ? 'checked' : ''} onclick="return false;"> H
            </label>
            <span style="margin-left:10px;"><br>Kim Yaptı? ___________</span>
          </div>
        </td>
      </tr>
        
      </tr>
    </table>
  `;
  }

  private renderDiagnosisTable(formData: any): string {
    const { caseData } = formData;

    // Diagnoses array'ini işleme
    const diagnosesRows = this.renderDiagnosesRows(caseData?.diagnoses ?? []);

    return `
      <table>
        <tr>
          <td colspan="2" style="font-weight:bold">ÖN TANI</td>
          <td style="font-weight:bold">ICD KODU</td>
          <td colspan="2" style="font-weight:bold">AÇIKLAMALAR</td>
        </tr>
        ${diagnosesRows}
      </table>
    `;
  }

  private renderDiagnosesRows(diagnoses: any[]): string {
    if (!diagnoses || diagnoses.length === 0) {
      return '<tr style="height:40px;"><td colspan="2"></td><td></td><td colspan="2"></td></tr>';
    }

    return diagnoses.map(diagnosis => `
    <tr style="height:40px;">
      <td style="width: fit-content;" colspan="2">${diagnosis?.icdCode?.name ?? ''}</td>
      <td style="width: 100px;">${diagnosis?.icdCode?.code ?? ''}</td>
      <td style="width: auto;" colspan="2">${diagnosis?.description ?? ''}</td>
    </tr>
  `).join('');
  }

  private renderResultTable(): string {
    const resultOptions = [
      'Hastaneye Nakil', 'Hastaneler Arası Nakil', 'Yerinde Müdahale', 'Tıbbi Tetkik İçin Nakil',
      'Eve Nakil', 'Ex', 'Ex Yerinde Bırakıldı', 'Ex Morga Nakil',
      'Nakil Reddi', 'Asılsız İhbar', 'Görev İptali', 'Başka Araçla Nakil',
      'Nakli Uygun Değil', 'Diğer', 'Ulaşılan Yaralanan Yok', 'Olay Yerinde Bekleme'
    ];
    const half = Math.ceil(resultOptions.length / 2);
    const col1 = resultOptions.slice(0, half);
    const col2 = resultOptions.slice(half);
    const renderColumn = (col: string[]) =>
      col.map(opt => `<label class="checkbox-item"><input type="checkbox" onclick="return false;"> ${opt}</label>`).join('<br>');
    return `
    <table>
      <tr class="section-header">
        <td colspan="2">SONUÇ</td>
        <td>NAKLEDİLEN HASTANE</td>
        <td>KAZAYA KARIŞAN ARAÇLARIN PLAKA NO</td>
      </tr>
      <tr style="height:60px; vertical-align:top;">
        <td style="width:35%; font-size:8px; line-height:1.3;">
          ${renderColumn(col1)}
        </td>
        <td style="width:35%; font-size:8px; line-height:1.3;">
          ${renderColumn(col2)}
        </td>
        <td style="width:15%; font-size:8px; line-height:1.3;">
          <label class="checkbox-item"><input type="checkbox" onclick="return false;"> Üniversite H.</label><br>
          <label class="checkbox-item"><input type="checkbox" onclick="return false;"> E.A.H.</label><br>
          <label class="checkbox-item"><input type="checkbox" onclick="return false;"> Devlet H.</label><br>
          <label class="checkbox-item"><input type="checkbox" onclick="return false;"> Özel H.</label><br>
          <label class="checkbox-item"><input type="checkbox" onclick="return false;"> Diğer</label>
        </td>
        <td style="width:15%; font-size:8px; line-height:1.3;">
          <div>1:___ 5:___</div>
          <div>2:___ 6:___</div>
          <div>3:___ 7:___</div>
          <div>4:___ 8:___</div>
        </td>
      </tr>
    </table>
  `;
  }

  private renderProcedureTable(formData: any): string {
    const data = formData.caseData;

    const processOptions = this.removeDuplicateOptions(data?.options?.processOptions ?? []);
    const generalOptions = this.removeDuplicateOptions(data?.options?.generalInterventionOptions ?? []);
    const fluidOptions = this.removeDuplicateOptions(data?.options?.fluidTherapyOptions ?? []);
    const medicationOptions = this.removeDuplicateOptions(data?.options?.medicationOptions ?? []);
    const materialOptions = this.removeDuplicateOptions(data?.options?.materialUsedOptions ?? []);
    const medicationPairs = this.getMedicationPairs(medicationOptions);

    const maxRows = Math.max(
      processOptions.length + (fluidOptions.length ? fluidOptions.length + 2 : 0),
      generalOptions.length,
      medicationPairs.length,
      materialOptions.length,
      1
    );

    let tableRows = '';
    for (let i = 0; i < maxRows; i++) {
      tableRows += this.renderTableRow(i, processOptions, fluidOptions, generalOptions, medicationPairs, materialOptions);
    }

    return `
    <div style="margin: 10px 0;">
        ${this.renderTableHeader()}
        <tbody>
            ${tableRows}
        </tbody>
        <div style="margin-top: 10px; font-size: 8px; color: #666;">
            <p><strong>*</strong> / <strong>**</strong> Kontrole Tabi İlaçlar (Yeşil ve Kırmızı Reçete)</p>
        </div>
    </div>
  `;
  }
  // ------------------- Yardımcı Fonksiyonlar -------------------
  private isOptionChecked(option: any): boolean {
    return !!option?.answerValue && option.answerValue !== 'Yapılmadı';
  }

  private removeDuplicateOptions(options: any[]): any[] {
    if (!options || !Array.isArray(options)) return [];
    const uniqueMap = new Map();
    for (const option of options) {
      const key = option?.questionId ?? option?.id;
      if (key && !uniqueMap.has(key)) uniqueMap.set(key, option);
    }
    return Array.from(uniqueMap.values());
  }

  private getMedicationPairs(options: any[]): { first: any; second: any }[] {
    const pairs = [];
    for (let i = 0; i < options.length; i += 2) {
      pairs.push({ first: options[i] ?? null, second: options[i + 1] ?? null });
    }
    return pairs;
  }

  private renderColumnCell(option: any): string {
    if (!option) return '<td></td><td></td><td></td><td></td>';
    const checked = this.isOptionChecked(option);
    return `
    <td style="text-align:center; width:30px;"><input type="checkbox" style="transform:scale(1.2);" ${checked ? 'checked' : ''} onclick="return false;"/></td>
    <td>${option?.answerLabel ?? ''}</td>
    <td style="text-align:center;">${option?.questionId ?? ''}</td>
    <td style="text-align:center;">${checked ? '1' : ''}</td>
  `;
  }

  private renderEmptyCells(count: number): string {
    return '<td></td>'.repeat(count);
  }

  // Örnek: tek satırı render eden fonksiyon
  private renderTableRow(
    i: number,
    processOptions: any[],
    fluidOptions: any[],
    generalOptions: any[],
    medicationPairs: any[],
    materialOptions: any[]
  ): string {
    let row = '<tr>';

    // İşlem Column
    if (i < processOptions.length) row += this.renderColumnCell(processOptions[i]);
    else row += this.renderEmptyCells(4);

    // Sıvı tedavisi vs. diğer kolonlar → benzer şekilde renderColumnCell ve koşullu header kullanılır
    // General Options Column
    if (i < generalOptions.length) row += this.renderColumnCell(generalOptions[i]);
    else row += this.renderEmptyCells(4);

    // Medication Pairs Column
    if (i < medicationPairs.length) {
      row += this.renderColumnCell(medicationPairs[i].first);
      row += this.renderColumnCell(medicationPairs[i].second);
    } else {
      row += this.renderEmptyCells(8);
    }

    // Material Used Column
    if (i < materialOptions.length) row += this.renderColumnCell(materialOptions[i]);
    else row += this.renderEmptyCells(4);

    row += '</tr>';
    return row;
  }

  private renderTableHeader(): string {
    return `
  <table style="width:100%; border-collapse: collapse; border:1px solid #000; margin-bottom:15px; font-size:9px;">
    <thead>
      <tr style="background-color:#f0f0f0;">
        <th colspan="4" scope="col">İŞLEM</th>
        <th colspan="4" scope="col">GENEL MÜDAHALE</th>
        <th colspan="4" scope="col">KULLANILAN İLAÇ</th>
        <th colspan="4" scope="col">KULLANILAN İLAÇ</th>
        <th colspan="4" scope="col">KULLANILAN MALZEME</th>
      </tr>
      <tr style="background-color:#f8f8f8;">
        ${'<th scope="col"></th><th scope="col"></th><th scope="col"></th><th scope="col"></th>'.repeat(5)}
      </tr>
    </thead>
  `;
  }

  private renderConsentSection(caseData: any): string {
    const data = caseData?.caseData?.data?.cases
    return `
      <div>
        <strong>HASTANIN HİZMET KABULÜ VEYA REDDİ:</strong>
        Ambulansla gelen görevli sağlık personeli bana hastanın hemen tedavisi / hastaneye nakli gerektiğini, aksi halde kötü sonuçlar doğurabileceğini anlayacağım şekilde ayrıntılı olarak anlattı. Yapılacak tedaviyi ve hasta naklini<br>
        <label class="checkbox-item"><input type="checkbox"> Kabul ediyorum</label>
        <label class="checkbox-item"><input type="checkbox"> Kabul etmiyorum</label>
        <br>Hasta veya Yakınının Adı Soyadı: ${data?.patientInformations?.firstName}  ${data?.patientInformations?.lastName} İmza: _________
      </div>
    `;
  }

  private renderSignatureTable(formData: any): string {
    const { doctor, driver, healthPersonnel, caseData } = formData;

    const doctorName = doctor ? `${doctor.firstName ?? ''} ${doctor.lastName ?? ''}`.trim() : '';
    const driverName = driver ? `${driver.firstName ?? ''} ${driver.lastName ?? ''}`.trim() : '';
    const personnel1Name = healthPersonnel[0] ? `${healthPersonnel[0].firstName ?? ''} ${healthPersonnel[0].lastName ?? ''}`.trim() : '';
    const personnel2Name = healthPersonnel[1] ? `${healthPersonnel[1].firstName ?? ''} ${healthPersonnel[1].lastName ?? ''}`.trim() : '';

    const dropoffInstitution = caseData?.data?.cases?.addressInformations?.dropoffInstitution;
    const institutionInfo = dropoffInstitution
      ? [
        dropoffInstitution.title,
        dropoffInstitution.signboard
      ]
        .filter(Boolean)
        .join(' - ')
      : '';

    return `
      <table style="margin-top:10px;">
        <tr class="section-header">
          <td>AMBULANS PERSONELİNİN ADI SOYADI</td>
          <td>İMZA</td>
          <td>HASTAYI TESLİM ALAN</td>
        </tr>
        <tr>
          <td>DOKTOR: ${doctorName}</td>
          <td></td>
          <td>Sağlık Kuruluşu: ${institutionInfo}</td>
        </tr>
        <tr>
          <td>YARDIMCI SAĞLIK PERSONELİ 1: ${personnel1Name}</td>
          <td></td>
          <td>Adı Soyadı / Kaşe</td>
        </tr>
        <tr>
          <td>YARDIMCI SAĞLIK PERSONELİ 2: ${personnel2Name}</td>
          <td></td>
          <td rowspan="2">İmza</td>
        </tr>
        <tr>
          <td>SÜRÜCÜ: ${driverName}</td>
          <td></td>
        </tr>
      </table>
    `;
  }

  private renderFooter(): string {
    return `
      <div class="footer">
        <p>Acıbadem Mobil Sağlık Hizmetleri A.Ş. ile paylaştığınız kişisel veriler, Kişisel Verilerin Korunması Kanunu'na uygun şekilde, faaliyet ve hizmet amaçlarımız ile bağlantılı, sınırlı ve ölçülü olarak kaydedilebilecek, depolanabilecek, muhafaza edilebilecek, yeniden düzenlenebilecek, kanunen bu kişisel verileri talep etmeye yetkili olan kurumlar ile paylaşılabilecek. Kişisel Verilerin Korunması Kanunu'nun öngördüğü şartlarda yurtiçindeki üçüncü kişilere aktarılmasını ve mevzuatta öngörülen süreler boyunca saklanmasını onaylıyorum.</p>
        <p><strong>Form No:</strong> OPR-F133</p>
        <p><strong>* / **</strong> Kontrole Tabi İlaçlar. (Yeşil ve Kırmızı Reçete)</p>
        <p><strong>!</strong> Hastanın hastaneye tesliminde, formun 2. nüshasının hastane tarafından alınıp arşivlenmesi zorunludur.</p>
        <p>"Eğer kolluk güçlerince trafik kaza raporu düzenlenmemiş ise mutlak surette durum kolluk güçlerinden alınacak bir tutanak ile kayıt altına alınarak bu forma eklenmesi</p>
        <p>Eğer kaza raporunda yayaya veya kazazedelere ait kusur belirtilmiş ise ilgili şahsın tüm kimlik bilgileri,ikamet adresi,telefon numararaları ve T.C kimlik numaralarının belirtilmeleri gerekmektedir.</p>
        <p><strong>Belge Doğrulama Kodu:</strong> 9a7b5509-cd78-4e6c-8935-79b4c844d0ff</p>
        <p><strong>Belge Doğrulama Adresi:</strong> https://www.turkiye.gov.tr/saglik-bakanligi-ebys</p>
        <p>Her kurumun kendi formu ve formun farklı bir numarasının olması ve bu formların 3(üç)nüsha şeklinde bastırılması gerekmektedir.</p>
        <p>Bu belge, güvenli elektronik imza ile imzalanmıştır.</p>
      </div>
    `;
  }
}